// extracted by mini-css-extract-plugin
module.exports = {"container":"container-DO2z9","navbar":"navbar-MslhZ"};